export const OPEN_CART = 'cart:open';
export const CART_UPDATED = 'cart:updated';
export const OPEN_PRODUCT = 'product:open';
export const OPEN_STAFF = 'staff:open';
